import { configureStore } from "@reduxjs/toolkit";
import homeSlice from "../slice/sliceHome";
import popupSlice from "../slice/slicePopup";
import { apiHome } from "../services/apiHome";
import { apiSlice } from "../services/apiSlice";

export const store = configureStore({
  reducer: {
    homeSlice,
    popupSlice,
    [apiHome.reducerPath]: apiHome.reducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiHome.middleware, apiSlice.middleware),
});
